import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";
import { getContracts } from "entities/contracts";
import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";
import ROUTES from "shared/routes";

export const ContractsSingWarning = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: contractsData } = useQuery({
    queryKey: ["contracts"],
    queryFn: () => getContracts(),
  });

  const contractsSingCount =
    contractsData?.data?.filter(
      (contract) =>
        ["SMS", "SMART_BRIDGE"].includes(contract?.sign_provider) &&
        contract?.edo_status?.code !== "FINISHED" &&
        contract?.edo_status?.code !== "SIGNED",
    ).length ?? 0;

  const contractsFinishedCount =
    contractsData?.data?.filter(
      (contract) =>
        contract?.edo_status?.code !== "FINISHED" &&
        contract?.edo_status?.code !== "SIGNED",
    ).length ?? 0;

  if (!contractsFinishedCount) {
    return null;
  }

  return (
    <div className={styles.block}>
      <div className={styles.iconWrapper}>
        <ExclamationCircleOutlined />
      </div>
      <Space vertical size="middle">
        <Typography.Text>{t("contracts.unresolved_document")}</Typography.Text>

        {!!contractsSingCount && (
          <Button type="primary" onClick={() => navigate(ROUTES.CONTRACTS)}>
            {t("contracts.sign_button")}
          </Button>
        )}
      </Space>
    </div>
  );
};
